import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import searchFilterSecurityRoles from "@tKgpco/Store/Data/SecurityRoles/Handlers/SearchFilterRoles";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    searchFilterSecurityRoles,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    isLoading: state.KGPState.SecurityRolesStore.isLoading,
    isLoadingOverlay: state.KGPState.SecurityRolesStore.isLoadingOverlay,
    roles: state.KGPState.SecurityRolesStore.roles,
    session: getSession(state),
    myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
    fieldstoHide: state.context.settings.properties.fieldsToHide || "",
    canshowPrice: state.context?.session?.properties?.canShowPrice?.toLowerCase() === "true",
});
const includeField = ["Security Roles"];
const includeRole = ["Administrator"];
interface CustomAccessorialsStyles {
    wrapper?: InjectableCss;
}

const styles: CustomAccessorialsStyles = {
    wrapper: {},
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory & ResolveThunks<typeof mapDispatchToProps>;

const RolesPage: React.FC<Props> = ({
    id,
    session,
    isLoadingOverlay,
    myAccountPageLink,
    searchFilterSecurityRoles,
    history,
    canshowPrice,
    fieldstoHide,
}) => {
    useEffect(() => {
        let flag = false;
        if (myAccountPageLink) {
            myAccountPageLink?.children
                ?.filter(child => {
                    const title = child?.title?.trim();

                    // Safely split and normalize excluded titles
                    const excludedTitles =
                        !canshowPrice && fieldstoHide ? fieldstoHide.split(",").map(t => t.trim().toLowerCase()) : [];

                    if (!title) {
                        return true;
                    }

                    return !excludedTitles.includes(title.toLowerCase());
                })
                ?.forEach(child => {
                    includeRole.forEach((role: string) => {
                        if (includeField.includes(child.title)) {
                            if (!(session.userRoles.indexOf(role) !== -1)) {
                                flag = true;
                            }
                        }
                    });
                    return flag;
                });

            if (flag) {
                history.push("/");
            }
        }
    }, [myAccountPageLink]);

    useEffect(() => {
        // searchFilterSecurityRoles({ page: 1 });
    }, []);

    return (
        <LoadingOverlay loading={isLoadingOverlay}>
            <StyledWrapper {...styles.wrapper}>
                <Zone contentId={id} zoneName="AccessorialsPageContainer" />
            </StyledWrapper>
        </LoadingOverlay>
    );
};

const securityRolesPageWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(RolesPage)),
    definition: {
        group: "Basic",
    },
};

export default securityRolesPageWidget;
